export default {
    apiKey: "AIzaSyAUvXSpRifxYR0nwNkJ_pDem_oou_YPkfw",
    authDomain: "opensourcejobs-db.firebaseapp.com",
    databaseURL: "https://opensourcejobs-db.firebaseio.com",
    projectId: "opensourcejobs-db",
    storageBucket: "opensourcejobs-db.appspot.com",
    messagingSenderId: "945035194774",
    appId: "1:945035194774:web:7c4a5e7558947d108aedb7"
}
